import React, { Component } from 'react';

import FormularioContactoModal from '../subcomponents/FormularioContactoModal';
class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = { modalAsunto: 'Contacto' };
  }

  render() {
    return (
      <div className="shortcode-html">
        <section className="g-bg-gray-light-v5 g-py-50 g-px-30">
          <div className="container">
            <div className="row">
              <div className="col-md-9 align-self-center">
                <h3 className="h4">Contáctate con nosotros</h3>
                Ponte en contacto con nosotros y uno de nuestros especialistas te apoyará con una
                asesoría en lo que necesitas.
              </div>
              <div className="col-md-3 align-self-center text-md-right g-mt-10">
                <button
                  data-modal-target="#contacto-modal"
                  onClick={() => {
                    this.setState({ modalAsunto: 'Formulario Contacto' });
                  }}
                  className="btn btn-md u-btn-outline-primary g-brd-2 rounded-0">
                  Contactar
                </button>
              </div>
            </div>
          </div>
        </section>
        <FormularioContactoModal asunto={this.props.asunto} />
      </div>
    );
  }
}
export default Contact;



// WEBPACK FOOTER //
// ./src/layout/Contact.js